export default "__VITE_ASSET__D9Ljp90U__"